module.exports = __webpack_public_path__ + "static/media/bg4.199e9ec1.jpg";